<template>
  <div class="result_content">
    <div class="topImg">
      <!-- <img src="@/assets/images/result.png" alt /> -->
      <h1>查询结果</h1>
    </div>
    <div class="mainContent">
      <div class="profile_picture">
        <div class="img">
          <img
            :src="!rankData.coachUser.profilePicture ? userImg:rankData.coachUser.profilePicture"
            @error="noImg()"
          />
        </div>
        <div class="info">
          <div class="nameContent">
            <p class="name">{{rankData.coachUser.coachName}}</p>
            <p
                    class="pinyin"
                    v-if="rankData.coachUser.coachNameGivenEn"
            >{{rankData.coachUser.coachNameGivenEn}} {{rankData.coachUser.coachNameFamilyEn}}</p>
            <p class="pinyin" v-else>--</p>
          </div>
          <div v-if="rankData.coachUser.organ_mark">
            <p>{{rankData.coachUser.organ_mark||'--'}}</p>
          </div>
        </div>
      </div>
      <div class="zzContent">
        <div class="headerbar">
          <img src="@/assets/images/zzlogo.png" alt />
          <span class="title">教练员执照</span>
        </div>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">等级</p>
              <p
                class="content grade"
                v-if="rankData.coachUser.coachLicenseNumber"
              >{{rankData.coachUser.coachRankType | level}}</p>
              <p v-else>暂无</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">有效期至</p>
              <p class="content grade">{{rankData.coachUser.coachLicenseEnd ||'暂无'}}</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <div class="col-24">
            <p class="labelTitle">执照编号</p>
            <p class="content grade">{{rankData.coachUser.coachLicenseNumber || '暂无'}}</p>
          </div>
        </el-row>
      </div>
      <div class="zsContent" v-if="rankData.coachAchievement.achievementStatus">
        <div class="headerbar" style="margin-top:10px">
          <img src="@/assets/images/zslogo.png" alt style="width:16px" />
          <span class="title">教练员证书</span>
        </div>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">等级</p>
              <p class="content grade">{{rankData.coachRank.coachRankType|level}}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">通过状态</p>
              <p class="content grade">{{rankData.coachAchievement.achievementStatus}}</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">所属年份</p>
              <p class="content grade">{{rankData.coachRank.coachRankYear}}年</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">主讲师</p>
              <p class="content grade">{{rankData.coachAchievement.lecturerName || "--"}}</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">举办方</p>
              <p class="content grade">{{rankData.coachRank.coachRankOrgan || "--"}}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">培训地点</p>
              <p class="content grade">{{rankData.coachAchievement.classAddress || "--"}}</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">培训开始时间</p>
              <p class="content grade">{{rankData.coachAchievement.classStart || "--"}}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">培训结束时间</p>
              <p class="content grade">{{rankData.coachAchievement.classEnd || "--"}}</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">证书编号</p>
              <p class="content grade">{{rankData.certificate.certificateNum || "--"}}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">编号时间</p>
              <p class="content grade">{{rankData.certificate.certificateDate || "--"}}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="infoContent">
        <div class="headerbar" style="margin-top:10px">
          <img src="@/assets/images/infologo .png" alt style="width:16px" />
          <span class="title">基本信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">性别</p>
              <p class="content grade">{{rankData.coachUser.coachSex}}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">国籍</p>
              <p class="content grade">{{rankData.coachUser.nationality}}</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">出生日期</p>
              <p class="content grade">{{rankData.coachUser.coachBirthday}}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">年龄</p>
              <p
                class="content grade"
                v-if="rankData.coachUser.coachBirthday"
              >{{ getAge(rankData.coachUser.coachBirthday) }}岁</p>
              <p class="content grade" v-else>--</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle">证件类型</p>
              <p class="content grade">{{rankData.coachUser.idNumber ? "中国居民身份证" : "护照"}}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="col-12">
              <p class="labelTitle" style="width:60%">教练员等级</p>
              <p
                class="content grade"
                style="width:40%"
                v-if="rankData.coachUser.coachRankType"
              >{{rankData.coachUser.coachRankType | level}}</p>
              <p class="content grade" style="width:40%" v-else>--</p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <div class="col-24">
            <p class="labelTitle">证件编号</p>
            <p
              class="content grade"
            >{{rankData.coachUser.idNumber || rankData.coachUser.idPassport}}</p>
          </div>
        </el-row>
        <el-row>
          <div class="col-24">
            <p class="labelTitle">注册足协</p>
            <p class="content grade">{{rankData.coachUser.organ_mark||'--'}}</p>
          </div>
        </el-row>
      </div>
<!--      <div class="searchButton" v-if="rankData.certificate.certificateUrl">-->
<!--        <a :href="rankData.certificate.certificateUrl" target="_blank">-->
<!--          <el-button class="btn">查看电子证书</el-button>-->
<!--        </a>-->
<!--      </div>-->
      <div  style="margin-bottom  :10px">
        <template v-if="rankData.coachRank.createCoachRank===3">
          <p v-if="rankData.coachRank.coachRankStatus==='有效'" style="font-size:12px;color:#b2b2b2">
            2008年12月31日之前参加岗位培训的足球教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见
            <span style="color: #4cd964">
              <a
                href="http://www.thecfa.cn/hitz/20190909/27995.html"
                target="_blank"
              >《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a>
            </span>
          </p>
        </template>
        <template v-else-if="rankData.coachRank.createCoachRank===4">
          <p v-if="rankData.coachRank.coachRankStatus==='有效'" style="font-size:12px;color:#b2b2b2">
            中国籍教练员在国外获得的教练员等级证书或在国内参加国外驻华或来华机构举办的教练员培训班获得的等级证书，通过中国足协认证后仅颁发新的执教执照，不再颁发新的电子证书，无需提交缺失资质审核。
          </p>
        </template>
        <template v-else>
          <p
          style="font-size:12px;color:#b2b2b2"
            v-if=" rankData.coachRank.coachRankStatus==='有效' && rankData.coachRank.coachRankType==='D' && Number(rankData.coachRank.coachRankYear) < 2019"
          >
            2018年12月31日之前参加培训的D级教练员不颁发电子证书，无需提交缺失资质审核。详细内容请参见
            <span style="color: #4cd964">
              <a
                href="http://www.thecfa.cn/hitz/20190909/27995.html"
                target="_blank"
              >《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</a>
            </span>
          </p>
          <p
          style="font-size:12px;color:#b2b2b2"
            v-else-if="!rankData.certificate.certificateUrl && rankData.certificate.certificateNum"
          >电子证书信息正在审核中，审核通过后将会短信通知。</p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { LevelFilters } from "@/assets/js/status";
import userImg from "@/assets/images/person.png";
export default {
  data() {
    return {
      userImg
    };
  },
  props: {
    rankData: {
      type: Object,
      required: true
    }
  },
  methods: {
    getAge(d) {
      return this.$yioks.jsGetAge(d);
    },
    noImg() {
      let img = event.srcElement;
      img.src = this.userImg;
      img.onerror = null;
    }
  },
  filters: {
    level(level) {
      if (!level) {
        return "暂无";
      }
      return LevelFilters(level);
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable';

html, body {
  height: 100%;
  width: 100%;
}

#app {
  min-width: unset;
  min-height: unset;
  height: 100%;
  width: 100%;
}

.result_content {
  width: 100%;
  height: 100%;
  background-color: white;

  .topImg {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('~@/assets/images/bg_d.png');
    background-size: cover;
    height: 15%;

    h1 {
      font-size: 18px;
      color: white;
      text-shadow: 0px 4px 10px rgba(51, 51, 51, 0.4);
      line-height: 1.5;
      font-weight: bold;
    }

    img {
      width: 27%;
    }

    /* height: 17%; */
  }

  .mainContent {
    padding: 0 2%;

    .profile_picture {
      margin: 10px 0;

      .img {
        text-align: center;

        img {
          width: 120px;
          height: 120px;
          border: 1px solid rgb(153, 153, 153);
          border-radius: 50%;
        }
      }

      .info {
        text-align: center;
        border-bottom: 1px solid rgba(0, 0, 0 0.1);
        .nameContent{
          display flex
          justify-content center
          align-items center
          flex-wrap wrap
          .name {
            color: rgb(51, 51, 51);
            font-weight: bold;
            font-size: 20px;
          }

          .pinyin {
            margin-top 5px
            margin-left 10px
            font-size: 13px;
            color: rgb(153, 153, 153);
          }
        }

      }
    }

    .zzContent, .zsContent, .infoContent {
      .headerbar {
        display: flex;
        align-items: center;
        padding-bottom: 5px;
        border-bottom: 1px solid rgba(0, 0, 0 0.1);

        img {
          width: 20px;
        }

        .title {
          color: rgb(42, 188, 89);
          font-weight: bold;
          font-size: 15px;
          margin-left: 5px;
        }
      }

      .el-row {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding: 10px 0 5px 0;
        display: flex;
        align-items: center;
      }

      .col-12 {
        display: flex;
        align-items: center;

        .labelTitle {
          padding: 0 5px;
          width: 45%;
          color: rgb(178, 178, 178);
        }

        .content {
          width: 55%;
        }
      }

      .col-24 {
        display: flex;
        align-items: center;
        width: 100%;

        .labelTitle {
          padding: 0 5px;
          width: 25%;
          color: rgb(178, 178, 178);
        }

        .content {
          width: 75%;
        }
      }
    }

    .infoContent {
      margin-bottom: 10px;
    }

    .searchButton {
      .btn {
        background-color: rgb(42, 188, 89);
        border: none;
        border-radius: unset;
        color: white;
        margin-bottom: 10px;
        width: 100%;
      }
    }
  }
}
</style>
